import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";

import CreateCustomerPage from "./CreateCustomerPage";
import CustomerContactDetailsPage from "./CustomerContactDetailsPage";
import CustomerOrderSettingsPage from "./CustomerOrderSettingsPage";
import CustomerDropsPage from "./CustomerDropsPage";
import CustomerUsersPage from "./CustomerUsersPage";
import CustomerLeadTimesPage from "./CustomerLeadTimesPage";
import CustomerCreditRequestSettingsPage from "./CustomerCreditRequestSettingsPage";

const AdminEditCustomer: IRoute[] = [
  {
    exact: true,
    path: "/admin/customers/:customerId/drops",
    title: "%DROPS%",
    pageComponent: CustomerDropsPage,
    menuType: "ADMIN_EDIT_CUSTOMER",
    context: "CREATE_EDIT_CUSTOMER",
    privateRoute: true,
    permissions: [ "view-customer" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/defaults",
    title: "Order settings",
    menuType: "ADMIN_EDIT_CUSTOMER",
    context: "CREATE_EDIT_CUSTOMER",
    permissions: [ "view-customer" ],
    pageComponent: CustomerOrderSettingsPage,
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/lead-times",
    title: "Lead Times",
    menuType: "ADMIN_EDIT_CUSTOMER",
    context: "CREATE_EDIT_CUSTOMER",
    permissions: [ "view-customer" ],
    pageComponent: CustomerLeadTimesPage,
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/contact-details",
    pageComponent: CustomerContactDetailsPage,
    title: "Contact Details",
    menuType: "ADMIN_EDIT_CUSTOMER",
    privateRoute: true,
    context: "CREATE_EDIT_CUSTOMER",
    permissions: [ "view-customer" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/users",
    pageComponent: CustomerUsersPage,
    title: "%USERS%",
    menuType: "ADMIN_EDIT_CUSTOMER",
    context: "CREATE_EDIT_CUSTOMER",
    privateRoute: true,
    permissions: [ "view-customer" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/customers/:customerId/credit-request-settings",
    pageComponent: CustomerCreditRequestSettingsPage,
    title: "Credit request settings",
    menuType: "ADMIN_EDIT_CUSTOMER",
    context: "CREATE_EDIT_CUSTOMER",
    privateRoute: true,
    modules: [ "credit-request" ],
    permissions: [ "view-customer" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  }
];

const AdminCreateCustomer: IRoute[] = [
  {
    exact: true,
    path: "/admin/customers/create",
    pageComponent: CreateCustomerPage,
    title: "Details",
    menuType: "ADMIN_CREATE_CUSTOMER",
    privateRoute: true,
    context: "CREATE_EDIT_CUSTOMER",
    permissions: [ "create-customer" ]
  },
  {
    exact: true,
    title: "Order settings",
    menuType: "ADMIN_CREATE_CUSTOMER",
    context: "CREATE_EDIT_CUSTOMER",
    permissions: [ "create-customer" ],
    disabled: true,
    privateRoute: true
  },
  {
    exact: true,
    title: "%DROPS%",
    menuType: "ADMIN_CREATE_CUSTOMER",
    context: "CREATE_EDIT_CUSTOMER",
    permissions: [ "create-customer" ],
    disabled: true,
    privateRoute: true
  },
  {
    exact: true,
    title: "%USERS%",
    menuType: "ADMIN_CREATE_CUSTOMER",
    context: "CREATE_EDIT_CUSTOMER",
    permissions: [ "create-customer" ],
    disabled: true,
    privateRoute: true
  }
];

export default [ ...AdminEditCustomer, ...AdminCreateCustomer ];
